import React from 'react'

import { inject, observer } from 'mobx-react'

import { UrlParamKey } from '~/client/src/shared/constants/commonRoutes'
import useWorkflows from '~/client/src/shared/hooks/useWorkflows'
import useWorkflowsByIds from '~/client/src/shared/hooks/useWorkflowsByIds'

import LogisticsComponent, { IProps } from './components/Logistics/Logistics'
import useWorkflowFacets from './useWorkflowFacets'
import useWorkflowsFilter from './useWorkflowsFilter'

const Logistics = (props: IProps) => {
  const {
    eventsStore: { appState },
  } = props

  const [datesFilter, setDatesFilter] = React.useState<{
    startDate?: number
    endDate?: number
  }>({
    startDate: undefined,
    endDate: undefined,
  })

  const filters = useWorkflowsFilter(appState)

  const { workflows } = useWorkflows(
    appState.activeProject.id,
    appState.user.id,
    {
      ...datesFilter,
      ...filters,
    },
    undefined,
    !datesFilter.startDate || !datesFilter.endDate,
  )

  const { facetsData: viewableFacets } = useWorkflowFacets(
    appState.activeProject.id,
    {
      ...datesFilter,
      ...filters,
    },
    { locationAttributesStore: props.locationAttributesStore },
  )

  const { facetsData: totalFacets } = useWorkflowFacets(
    appState.activeProject.id,
    {},
    { locationAttributesStore: props.locationAttributesStore },
  )

  const searchParams = new URLSearchParams(location.search)

  const deepLinkFormId = searchParams.get(UrlParamKey.Form)
  const deepLinkFormType = searchParams.get(UrlParamKey.FormType)

  const { workflows: deepLinkedForms } = useWorkflowsByIds(
    appState.activeProject.id,
    deepLinkFormId ? [deepLinkFormId] : [],
  )

  return (
    <LogisticsComponent
      {...props}
      workflows={workflows}
      viewableFacets={viewableFacets}
      totalFacets={totalFacets}
      onDatesFilterChange={setDatesFilter}
      deepLinkedForm={deepLinkedForms?.[0]}
      deepLinkFormType={deepLinkFormType}
    />
  )
}

export default inject(
  'eventsStore',
  'locationAttributesStore',
)(observer(Logistics))
